import { gql } from '@/__generated__/gql';

export const MANAGER_SPOTLIGHT_INVESTMENTS_QUERY = gql(`
  query ManagerSpotlightWizardPageManagerSpotlightInvestments($tenantIds: [String!]!) {
    managerSpotlightInvestments(tenantIds: $tenantIds) {
      id
      name
    }
  }
`);

export const MANAGER_SPOTLIGHT_EMAIL_PREVIEW_QUERY = gql(`
  query ManagerSpotlightWizardPageManagerSpotlightEmailPreview($data: ManagerSpotlightEmailInputDto!) {
    managerSpotlightEmailPreview(data: $data) {
      previewData {
        substitution_data {
          recipientFirstName
          subject
          message
          strategies {
            securityStatus
            investments {
              name
              summary
              subAssetClass {
                name
              }
              assetClass {
                name
              }
              illiquid
              pacingType
              pacingStartingYear
              pacingStartingQuarter
              sectors
            }
          }
        }
      }
      totalUserCount
    }
  }
`);

export const MANAGER_SPOTLIGHT_EMAIL_MUTATION = gql(`
  mutation ManagerSpotlightWizardPageManagerSpotlightEmail($data: ManagerSpotlightEmailInputDto!) {
    managerSpotlightEmail(data: $data)
  }
`);
